var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultLoader',{attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color,"px":_vm.px,"py":_vm.py}},[(_vm.show)?_vm._t("default"):[_c('p',{staticClass:"text-center subtitle-1",domProps:{"innerHTML":_vm._s(_vm.text)}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }